import { render } from "./PercentChart.vue?vue&type=template&id=c6347806"
import script from "./PercentChart.vue?vue&type=script&lang=js"
export * from "./PercentChart.vue?vue&type=script&lang=js"

import "./PercentChart.vue?vue&type=style&index=0&id=c6347806&lang=css"
script.render = render

export default script